export default "__VITE_ASSET__BMqeBeeK__"